import React from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import HipodromoCard, {Hip} from "../hipodromo/componenters/hipodromoCard";

import {MDBTypography} from "mdb-react-ui-kit";
import Logo from "../../PuerilAlgritmo_Icon.png";
import logo_hipodromo_chile from '../../statics/img/logos/logo_hipodromo_chile.png'
import { TermsCheckRequest, checkTermsAcceptance } from "../../services/terms";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../context/Login.context";

const hipodromos:Hip[] = [
  {
    id: 1,
    nombre: 'Hipódromo Chile',
    ubicacion: 'Santiago',
    imagen: logo_hipodromo_chile as string
  },
  {
    id: 2,
    nombre: 'Club Hípico',
    ubicacion: 'Santiago',
    imagen: 'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fmir-s3-cdn-cf.behance.net%2Fprojects%2F404%2Fe0dfc7183440837.Y3JvcCwxMDA4LDc4OSwyMjQsMA.jpg&f=1&nofb=1&ipt=cd240fab2262c70ab9d5f9d68229e646d9ca5335a736ad0ffb4cb9c0e1d6d61e&ipo=images',
    disabled: false
  },
];

const WelcomeScreen = () => {
  const navigate = useNavigate();
  const {checkAuth} = useAuth()
  React.useEffect(()=>{
    const get_check = async ()=>{
      const checkTerms = await checkTermsAcceptance()
      await checkAuth()
      if ((checkTerms as TermsCheckRequest).acceptance_required){
          navigate(`/terminos`)
        }
    }
    get_check().then()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[navigate])
  return (
    <>
      <Container sx={{ pb: 10 }}>
        <Box sx={{ my: 4 }}>
          <figure className='text-center mb-0'>

            <MDBTypography blockquote>
              <img src={Logo as string} width={150} alt='Logo'/>
            </MDBTypography>
            <figcaption className='blockquote-footer mb-0'>
              el potro inteligente
            </figcaption>

          </figure>
          <Typography variant="subtitle1" align="center" color="text.secondary">
            Selecciona un hipódromo para comenzar
          </Typography>
        </Box>

        <Grid container justifyContent="center" spacing={3} id="hipodromo-selector-container">
          {hipodromos.map((hipodromo) => (
              <Grid item key={hipodromo.id} xs={12} sm={6} md={4} display="flex" justifyContent="center">
                <HipodromoCard id={hipodromo.id} ubicacion={hipodromo.ubicacion} imagen={hipodromo.imagen}
                               nombre={hipodromo.nombre} disabled={hipodromo.disabled}/>
              </Grid>
          ))}
        </Grid>
      </Container>

    </>
  );
};

export default WelcomeScreen;